import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide12GoodNewsTitle.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide12GoodNewsTitle(_props: SlideProps) {
  const c = useSlideCopy(copy)

  return (
    <div className="min-h-[50vh] flex items-center justify-center text-center px-4">
      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1, ease }}
        className="text-5xl sm:text-7xl font-semibold text-slate-900 tracking-tight leading-[1]"
      >
        {c.title}
      </motion.h2>
    </div>
  )
}
